import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getBranchAssigned = async ({ token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.GET_BRANCH_ASSIGNED}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default getBranchAssigned;